// extracted by mini-css-extract-plugin
export default {"Welcome":"Welcome_Welcome__sPAqt"};